// Logos are kept inside the business record (at most 1 MB), so a picked
// image is scaled down in the browser until it fits the phone app's limit.
import { MAX_LOGO_BYTES } from '@/core/business';

const bytesOf = (dataUri: string) => Math.ceil(((dataUri.length - dataUri.indexOf(',') - 1) * 3) / 4);

function load(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Not an image'));
    };
    image.src = url;
  });
}

/** The image as a data URI under the limit; null when it can't be made small enough. */
export async function logoFromFile(file: File): Promise<string | null> {
  const image = await load(file);
  for (const side of [512, 384, 256, 192]) {
    const scale = Math.min(1, side / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    canvas.getContext('2d')!.drawImage(image, 0, 0, canvas.width, canvas.height);
    // PNG keeps transparent logos clear; a photo may only fit as JPEG.
    for (const uri of [canvas.toDataURL('image/png'), canvas.toDataURL('image/jpeg', 0.85)]) {
      if (bytesOf(uri) <= MAX_LOGO_BYTES) return uri;
    }
  }
  return null;
}
